import { html } from 'omni-ui';
import { Om2FormFieldBase } from './common/base.js';

/**
 * Render a hidden input field.
 */
export class Om2FormFieldHidden extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Hidden Input',
      fields: {
        id: {
          title: 'Unique Id',
          type: 'string',
          required: true,
          formModal: { fullWidth: true },
        },
        override: {
          title: 'Value',
          type: 'string',
          multiline: true,
          tooltip:
            'This hidden value is constant and not controlled by the user',
          formModal: { fullWidth: true },
        },
      },
    },
  };

  render() {
    const { schema } = this;
    return html`
      <input
        type="hidden"
        .name="${this.key}"
        .value=${schema.override ?? this.data ?? schema.default ?? ''}
      />
    `;
  }
}

Om2FormFieldHidden.register('hidden');
